import { Directive, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAutoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {

  constructor(
    private ele: ElementRef,
    private render: Renderer2
  ) {
    this.ele.nativeElement.setAttribute('tabindex', '-1');
  }

  ngAfterViewInit() {
    this.ele.nativeElement.focus();
  }
}
